export interface ISanitizedHtmlProps {
  /** Pre-sanitized HTML (sanitized at the data-access boundary). */
  html: string
}

export const SanitizedHtml = ({ html }: ISanitizedHtmlProps) => (
  <div dangerouslySetInnerHTML={{ __html: html }} />
)

SanitizedHtml.displayName = 'SanitizedHtml'
